module.exports = __webpack_public_path__ + "static/media/iep-ui-design04.b9835eda.png";